import { components } from "react-select";

import classes from "./CropInput.module.scss";

const CropInput = (props) => {
	const data = props.data;

	return (
		<components.Option style={{ background: "red", minWidth: "100%", minHeight: "100" }} {...props}>
			<div className={classes.cropOption}>
				<span>{data.label.toUpperCase()}</span>
				{!data.__isNew__ && !data.customer_id && (
					<div>
						<img src={"/sag.jpg"} alt={"SAG"} />
					</div>
				)}
			</div>
		</components.Option>
	);
};

const CustomSingleValue = (props) => {
	const { data } = props;
	return (
		<components.SingleValue {...props}>
			<div className={classes.cropSelected}>
				<span>{data.label.toUpperCase()}</span>
				{!data.customer_id && (
					<div>
						<img src={"/sag.jpg"} alt={"SAG"} />
					</div>
				)}
			</div>
		</components.SingleValue>
	);
};

export { CropInput, CustomSingleValue };
